import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postUpdateOrganization = (params) => {
    return axios.post(`${backendHost}/api/admin/object/update`, params);
};

export {
    postUpdateOrganization
}